// extracted by mini-css-extract-plugin
export var columnList = "_et-0";